import type { FlexProps } from '@chakra-ui/react'
import { Flex } from '@chakra-ui/react'

import { DateSelectorItem } from './DateSelectorItem'
import type { ReactNode } from 'react'

export interface DateSelectorProps<T> extends Omit<FlexProps, 'onChange'> {
  options: {
    name: string | ReactNode
    value: T
  }[]
  value: T
  onChange: (value: T) => void
}

export function DateSelector<T>({
  options,
  value,
  onChange,
  ...rest
}: DateSelectorProps<T>) {
  return (
    <Flex {...rest}>
      {options?.map(({ name, value: optionValue }, i) => {
        return (
          <DateSelectorItem
            key={i}
            isActive={optionValue === value}
            onClick={() => onChange(optionValue)}
          >
            {name}
          </DateSelectorItem>
        )
      })}
    </Flex>
  )
}
